import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  hospitalId: string | undefined;
}

interface Result {}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/scan/generate_from_files',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useGenerateScans = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useGenerateScansLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useGenerateScans;
